module.exports = __webpack_public_path__ + "static/img/market01.99fcd53e.png";